import { BaseOptionType } from 'antd/lib/select';
import { CSSProperties, ReactNode } from 'react';

export type BaseFormItemProps<T> = {
  onChange?: (value: T) => void;
  value?: T;
  defaultValue?: T;
};

export type PropsWithStyles<T> = T & {
  style?: CSSProperties;
  className?: string;
};

export const TDS_SEARCH_VALUES = 'search_value_storage_3';

export type TdsSearchValue= {id: string, name: string, values: Record<string, any>};

export type TdsSearchValueStorageType = TdsSearchValue[];

export interface OptionType extends BaseOptionType {
  label: ReactNode;
  value?: string | number | null;
}

export enum TdsColumnGroup {
  UserInfo = 'userInfo',
  ApplicationInfo = 'applicationInfo',
  DeviceInfo = 'deviceinfo',
  ContextInfo = 'contextInfo',
  exceptionInfo = 'exceptionInfo',
  Tag = 'tag',
  Custom = 'custom'
}
